import styled from 'styled-components';
import { Icon } from '..';
import { useState, useRef, useEffect } from 'react';

const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`;

const Selector = styled.div`
  display: flex;
  cursor: pointer;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

const Arrow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  height: 100%;
  width: 24px;
  cursor: pointer;
  position: absolute;
  right: 0;
`;

const DropdownContainer = styled.div`
  min-width: 160px;
  position: absolute;
  top: calc(100% + 4px); /* Space between button and dropdown */
  left: 50%; /* Position at 50% from the left */
  transform: translateX(-50%); /* Center the dropdown */
  width: 100%;
  background-color: #001c4f;
  padding: 12px;
  border-radius: 8px; /* Rounded corners */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Shadow for depth */
  z-index: 101; /* Ensure dropdown appears above other elements */
`;

const Value = styled.div`
  font-weight: 700;
  width: 100%;
  color: #fff;
  text-align: center;
`;

export function Dropdown({ children, trigger, className, isOpen, onToggle }) {
  const [localShow, setLocalShow] = useState(false);
  const containerRef = useRef(null);

  // Determine if component is controlled or uncontrolled
  const isControlled = isOpen !== undefined && onToggle !== undefined;
  const show = isControlled ? isOpen : localShow;

  const toggle = () => {
    if (isControlled) {
      onToggle();
    } else {
      setLocalShow(!localShow);
    }
  };

  // Add click-outside handler
  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        if (isControlled) {
          onToggle(false);
        } else {
          setLocalShow(false);
        }
      }
    }

    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [show, isControlled, onToggle]);

  return (
    <Container
      ref={containerRef}
      className={className}>
      <Selector onClick={toggle}>
        {typeof trigger === 'string' ? <Value>{trigger}</Value> : trigger}
        <Arrow>
          <Icon
            name="chevron-down"
            size={16}
            color="#fff"
          />
        </Arrow>
      </Selector>
      {show && <DropdownContainer>{children}</DropdownContainer>}
    </Container>
  );
}
